import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import lottieWeb from 'lottie-web'

class Benefits {
  index = 0
  autoplay = true
  autoplayDelay = 12000
  lotties = []

  constructor(el) {
    this.buttons = el.querySelectorAll('.benefits__entry')
    this.animations = el.querySelectorAll('.benefits__animation')

    this.buttons[0].classList.add('active')
    this.animations[0].classList.add('active')

    if (window.innerWidth > 1024) {
      this.setupEvents()
      this.setupLottieAnimations(false)
      
      if (this.autoplay) {
        this.setupAutoplay()
        this.triggerButtonAnimation()
      }
    } else {
      this.setupLottieAnimations(true)
    }
  }
  setupEvents() {

    this.buttons.forEach((button, i) => {
      button.addEventListener('click', this.changeSlide.bind(this, i, true))
    })
  }
  setupLottieAnimations(autoplay) {

    this.animations.forEach(container => {
      const name = container.dataset.lottie
      const anim = lottieWeb.loadAnimation({
        container: container,
        loop: true,
        autoplay: autoplay,
        renderer: 'svg',
        path: '/lottie/' + name + '.json',
        rendererSettings: {
          progressiveLoad: true
        }
      })
      this.lotties.push(anim)
    })

    if (this.autoplay) {
      this.lotties[0].play()
    }

  }
  setupAutoplay() {

    this.interval = setInterval(() => {
      if (this.buttons[this.index + 1]) {
        this.changeSlide(this.index + 1)
      } else {
        this.changeSlide(0)
      }
    }, this.autoplayDelay)
  }
  stopAutoplay() {

    this.autoplay = false

    clearInterval(this.interval)
    
    gsap.set(this.buttons, {
      clearProps: 'all',
      backgroundPositionX: '0%',
      overwrite: true
    })

  }
  changeSlide(i, clicked) {
    this.index = i
    this.buttons.forEach(el => el.classList.remove('active'))
    this.buttons[i].classList.add('active')
    this.animations.forEach(el => el.classList.remove('active'))
    this.animations[i].classList.add('active')
    this.lotties.forEach(animation => animation.stop())
    this.lotties[i].play()

    if (clicked) {
      this.stopAutoplay()
    }

    if (this.autoplay) {      
      this.triggerButtonAnimation()
    }
  }
  triggerButtonAnimation() {

    if (this.buttons[this.index + 1]) {
      gsap.to(this.buttons[this.index + 1], {
        duration: this.autoplayDelay / 1000,
        backgroundPositionX: '-100%',
        ease: 'power1',
        clearProps: 'all'
      })
    } else {
      gsap.to(this.buttons[0], {
        duration: this.autoplayDelay / 1000,
        backgroundPositionX: '-100%',
        ease: 'power1',
        clearProps: 'all'
      })
    }
    
  }
}

export const initBenefits = () => {
  
  const sections = document.querySelectorAll('.benefits')

  if (!sections.length) return
  
  sections.forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      once: true,
      onEnter: () => new Benefits(section)
    })
  })
}

export default () => {}